import Vue from 'vue'
import langs from '@/i18n/index.json'

Vue.filter('t', function (value) {
  return langs['en-us'][value]
})
